import { render, staticRenderFns } from "./LeadBox.vue?vue&type=template&id=eec972fc&scoped=true&"
import script from "./LeadBox.vue?vue&type=script&lang=js&"
export * from "./LeadBox.vue?vue&type=script&lang=js&"
import style0 from "./LeadBox.vue?vue&type=style&index=0&id=eec972fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eec972fc",
  null
  
)

export default component.exports